const maxY = 150;
let body;
let bodyClasses;

/**
 * scrollCheck
 * @description check different features for scroll rules
 */
const scrollCheck = () => {
    if (window.pageYOffset > maxY) {
        body.className = bodyClasses + ' scrolled';
    } else {
        body.className = bodyClasses;
    }
};

/**
 * onScrollInit
 * @description A simple scroll event manager
 */
const onScrollInit = () => {
    body = document.body;
    bodyClasses = body.className;

    window.addEventListener('scroll', scrollCheck);
};

export {
    onScrollInit
};
